/**
 * Minimal status surface for cloud sync. qda has no toast/Events-emitter UI
 * (checked before adding this) — this is the smallest thing that lets the
 * "Sync now" settings action and any future indicator show current state.
 */
import { create } from "zustand";

export type SyncStatus = "idle" | "syncing" | "success" | "error";

interface SyncStatusStore {
  status: SyncStatus;
  message: string | null;
  lastSyncedAt: string | null;
  setStatus: (status: SyncStatus, message?: string) => void;
}

export const useSyncStatusStore = create<SyncStatusStore>((set) => ({
  status: "idle",
  message: null,
  lastSyncedAt: null,
  setStatus: (status, message) =>
    set((state) => ({
      status,
      message: message ?? null,
      // Only overwritten on success — an error/syncing tick must not erase
      // the last time sync actually succeeded.
      lastSyncedAt: status === "success" ? new Date().toISOString() : state.lastSyncedAt,
    })),
}));
